module.exports = __webpack_public_path__ + "img/icon-3.26bdfb7.png";